import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import history from "../../../router/browserrouter";
import { store } from "../../store";
export default function* watcherGetStorageTanksSaga() {
  yield takeEvery("LOAD_STORAGE_TANKS", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    var payload = {};

    var formatUrl = `/get-storage-tanks`;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "STORAGE_TANKS_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER", payload: payload });
  } catch (e) {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log("Storage Tanks -saga", e);
    console.log("Storage-Tanks-Saga", e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
